<template>
  <div>Aside</div>
</template>

<script>
export default {
}
</script>
